import {
  CHECK_NEW_NOTIFICATIONS,
  CLOSE_NOTIFICATION_MODAL,
  GET_NOTIFICATIONS_BY_USER,
  GET_NOTIFICATIONS_BY_USER_FAILED,
  GET_NOTIFICATIONS_BY_USER_SUCCESS,
  MARK_NOTIFICATION_AS_READ,
  MARK_NOTIFICATION_AS_READ_FAILED,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  OPEN_NOTIFICATION_MODAL,
} from './constants';

export const getNotificationsByUser = (userId) => ({
  type: GET_NOTIFICATIONS_BY_USER,
  payload: { userId },
});

export const getNotificationsByUserSuccess = (notifications) => ({
  type: GET_NOTIFICATIONS_BY_USER_SUCCESS,
  payload: { notifications },
});

export const getNotificationsByUserFailed = (error) => ({
  type: GET_NOTIFICATIONS_BY_USER_FAILED,
  payload: { error },
});

export const markNotificationAsRead = (notificationId) => ({
  type: MARK_NOTIFICATION_AS_READ,
  payload: { notificationId },
});

export const markNotificationAsReadSuccess = (notification) => ({
  type: MARK_NOTIFICATION_AS_READ_SUCCESS,
  payload: { notification },
});

export const markNotificationAsReadFailed = (error) => ({
  type: MARK_NOTIFICATION_AS_READ_FAILED,
  payload: { error },
});

export const openNotificationModal = () => ({
  type: OPEN_NOTIFICATION_MODAL,
});

export const closeNotificationModal = () => ({
  type: CLOSE_NOTIFICATION_MODAL,
});

export const checkNewNotifications = () => ({
  type: CHECK_NEW_NOTIFICATIONS,
});
